import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Race } from '../../models/race.model';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatRippleModule } from '@angular/material/core';
import { raceSelectRippleOptions } from '../../constants/ripple-options.constant';

@Component({
  selector: 'app-race',
  imports: [CommonModule, TranslateModule, MatRippleModule],
  templateUrl: './race.component.html',
  styleUrl: './race.component.scss',
})
export class RaceComponent implements OnInit, OnChanges {
  @Input() selectedRaceId?: number;
  @Input() races: Race[] = [];
  @Output() raceSelected = new EventEmitter<number>();
  rippleOptions = raceSelectRippleOptions
  get stepNumber() {
    return 2;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['races']?.currentValue[0] || changes['selectedRaceId']?.currentValue) {      
      this.selectRace(changes['races']?.currentValue[0].id ?? changes['selectedRaceId']?.currentValue)
    }
  }
  ngOnInit(): void {}

  isRaceSelected(RaceId: number) {
    return this.selectedRaceId === RaceId;
  }
  selectRace(RaceId: number) {    
    this.selectedRaceId = RaceId;
    this.raceSelected.emit(RaceId);
  }
}
